import { ref, computed } from "vue";

/**
 * @NOTE: This doesn't exist in API form. It's set based on the data of the membership_type state
 * 
 * @returns {Object<details: Ref<Object>>}
 */
export default function createPricingData() {

    /**
     * These should be set based on the availabilities of the membership_type api
     */
    const details = ref([])

    /**
     * Holds the payment type we should be finding pricing for
     * 
     * This should be modified by the form state to update pricing accordingly
     */
    const payment_type = ref('annual')

    /**
     * Holds the name of the availability we should be referencing prices for
     * 
     * This should be modified by the user state upon retrieving details (if authenticated this should be additional-memberships)
     */
    const price_type = ref('new-members')

    /**
     * If we should be making a single annual payment
     */
    const is_annual_payment = computed(
        () => payment_type.value === 'annual'
    )

    /**
     * Finds the availability for the given price_type
     */
    const availability = computed(
        () => details.value.find(
            availability => availability.availability.value === price_type.value
        )
    )

    /**
     * Finds the price for the given payment type
     * 
     * Checks the found availability for a field under the same name
     */
    const price_for_payment_type = computed(
        () => parseFloat(availability.value?.[`${payment_type.value}_price`])
    )

    /**
     * The amount we will be charged today
     */
    const todays_price = computed(
        () => availability === undefined
            ? 'N/A'
            : price_for_payment_type.value.toFixed(2)
    )

    /**
     * The amount we will be charged in total over the span of the membership
     */
    const total_price = computed(
        () => {
            if (availability.value === undefined) {
                return 'N/A'
            }

            return is_annual_payment.value
                ? todays_price.value
                : (price_for_payment_type.value * 2).toFixed(2)
        }
    )

    return {
        details: details,

        payment_type: payment_type,
        price_type: price_type,

        is_annual_payment: is_annual_payment,
        availability: availability,
        price_for_payment_type: price_for_payment_type,
        todays_price: todays_price,
        total_price: total_price,

        has_availability_for_payment_type: (paymentType) => availability.value?.[`${paymentType}_price`] !== null
    }
}